import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Job } from "../../docuclipper/DocuclipperTypes";

const initialState: {
  exportType: Job["jobType"] | "xlsx" | "csv" | "qbo" | null;
  downloadModalOpen: boolean;
  downloadInvoiceModalOpen: boolean;
  downloadFormModalOpen: boolean;
  downloadTemplateModalOpen: boolean;
} = {
  exportType: null,
  downloadModalOpen: false,
  downloadInvoiceModalOpen: false,
  downloadFormModalOpen: false,
  downloadTemplateModalOpen: false,
};

const slice = createSlice({
  name: "JobExport",
  initialState,
  reducers: {
    setExportType(state, action: PayloadAction<Job["jobType"] | null>) {
      state.exportType = action.payload;
    },
    setDownloadModalOpen(state, action: PayloadAction<boolean>) {
      state.downloadModalOpen = action.payload;
    },
    setDownloadInvoiceModalOpen(state, action: PayloadAction<boolean>) {
      state.downloadInvoiceModalOpen = action.payload;
    },
    setDownloadFormModalOpen(state, action: PayloadAction<boolean>) {
      state.downloadFormModalOpen = action.payload;
    },
    setDownloadTemplateModalOpen(state, action: PayloadAction<boolean>) {
      state.downloadTemplateModalOpen = action.payload;
    },
  },
});

export const {
  setExportType,
  setDownloadModalOpen,
  setDownloadInvoiceModalOpen,
  setDownloadFormModalOpen,
  setDownloadTemplateModalOpen,
} = slice.actions;

export default slice.reducer;
